SupportGoodsShippingStatusAndNotesPresentation =
  editable:
    notes: "You can edit this order and your shipping details until it is processed."
    status: "Processing"

    available:
      fulfilled_enabled:
        status: "Ordered"
        notes: "You can still make changes to this order until {{isEditableUntil}}"

      shipments_available:
        status: "Shipped"
        notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery."

        returnable:
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery."

          return_initiated_label_not_printed:
            status: "Returns Initiated"
            notes: "Your return for this item is currently in progress."
          return_initiated_label_printed:
            status: "Processing Returns"
            notes: "Your return for this item is currently in progress."

        not_returnable:
          time_exceeded:
            notes: "This Groupon Goods purchase is no longer returnable. Items must be returned within 14 days of delivery."
          non_returnable:
            notes: "As stated in the deal's Fine Print, this Groupon Goods purchase is not returnable."

      shipments_processing:
        status: "Ordered"
        notes: "Tracking information is not available for this order, but your Groupon Goods should arrive within two and a half weeks of your purchase date."

        returnable:
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery."

          return_initiated_label_not_printed:
            status: "Returns Initiated"
            notes: "Your return for this item is currently in progress."
          return_initiated_label_printed:
            status: "Processing Returns"
            notes: "Your return for this item is currently in progress."

      shipments_not_available:
        status: "Ordered"
        notes: "Tracking information is not available for this order, but your Groupon Goods should arrive within two and a half weeks of your purchase date."

        returnable:
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery."

          return_initiated_label_not_printed:
            status: "Returns Initiated"
            notes: "Your return for this item is currently in progress."
          return_initiated_label_printed:
            status: "Processing Returns"
            notes: "Your return for this item is currently in progress."

  not_editable:
    order_received:
      status: "Ordered"
      dropship:
        notes: "Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. You can expect to receive an email with tracking information within 2-4 business days of your purchase."

      "post-deal_purchase_3pl":
        notes: "Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. You can expect to receive an email with tracking information within 6-9 business days of your purchase."

      "pre-deal_purchase_3pl":
        notes: "Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. You can expect to receive an email with tracking information within 2-4 business days of your purchase."

    processing_order:
      status: "Processing order"
      dropship:
        notes: "You can expect to receive an email with tracking information within 2-4 business days of your purchase. Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed."

      "post-deal_purchase_3pl":
        notes: "You can expect to receive an email with tracking information within 6-9 business days of your purchase. Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed. "

      "pre-deal_purchase_3pl":
        notes: "You can expect to receive an email with tracking information within 2-4 business days of your purchase. Your order was placed {{number_of_business_days_ago}} business days ago and can no longer be changed."

    preparing_shipment:
      status: "Preparing to Ship"
      dropship:
        notes: "{{shipping_soon_msg_plus_two_business_days}} This order can no longer be changed."

      "post-deal_purchase_3pl":
        notes: "{{shipping_soon_msg}} This order can no longer be changed."

      "pre-deal_purchase_3pl":
        notes: "{{shipping_soon_msg_plus_two_business_days}} This order can no longer be changed."

    shipped:
      status: "In Transit"
      dropship:
        notes: "Your order shipped on {{shipped_date}} and is on its way to you!. You can expect delivery within 4-7 business days from this date."

      "post-deal_purchase_3pl":
        notes: "Your order shipped on {{shipped_date}} and is on its way to you!. You can expect delivery within 4-7 business days from this date."

      "pre-deal_purchase_3pl":
        notes: "Your order shipped on {{shipped_date}} and is on its way to you!. You can expect delivery within 4-7 business days from this date. Please allow up to 72 hours for tracking information to be available from the shipping company."

    out_for_delivery:
      status: "Out for delivery"
      notes: "Your order is out for delivery on {{out_for_delivery_date}}!"

    delivered:
      status: "Delivered"
      notes: "Your order was delivered on {{delivered_date}}"

    error:
      status: "Shipped"
      notes: "Please visit {{carrier_name}} website for progress on you shipment. Your tracking number is {{tracking_number}}"

    available:
      shipments_available:
        status: "Shipped"
        notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery."

        returnable:
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery."

          return_initiated_label_not_printed:
            status: "Returns Initiated"
            notes: "Your return for this item is currently in progress."
          return_initiated_label_printed:
            status: "Processing Returns"
            notes: "Your return for this item is currently in progress."

        not_returnable:
          time_exceeded:
            notes: "This Groupon Goods purchase is no longer returnable. Items must be returned within 14 days of delivery."
          non_returnable:
            notes: "As stated in the deal's Fine Print, this Groupon Goods purchase is not returnable."

      shipments_processing:
        status: "Processing order"
        notes: "Tracking information is not available for this order, but your Groupon Goods should arrive within two and a half weeks of your purchase date."

        returnable:
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery."

          return_initiated_label_not_printed:
            status: "Returns Initiated"
            notes: "Your return for this item is currently in progress."
          return_initiated_label_printed:
            status: "Processing Returns"
            notes: "Your return for this item is currently in progress."

      shipments_not_available:
        status: "Processing order"
        notes: "Tracking information is not available for this order, but your Groupon Goods should arrive within two and a half weeks of your purchase date."

        returnable:
          notes: "Unless the deal's Fine Print states otherwise, you can return Groupon Goods anytime within 14 days of delivery."

          return_initiated_label_not_printed:
            status: "Returns Initiated"
            notes: "Your return for this item is currently in progress."
          return_initiated_label_printed:
            status: "Processing Returns"
            notes: "Your return for this item is currently in progress."

    redeemed:
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>"
      notes: ""

    expired:
      status: "Expired"
      notes: ""

    expired_unredeemed:
      status: "Expired"
      notes: ""

    expired_redeemed:
      status: "Used on <span class='localtime'>{{redeemed_date}}</span>"
      notes: ""

module.exports = SupportGoodsShippingStatusAndNotesPresentation
